export function routes(
  state = {
    machines: "/machines",
    stores: "/stores",
    create: "/comment-form",
    savedForms: "/saved-forms",
    barcodeScanner: "/barcode-scanner"
  },
  action
) {
  switch (action.type) {
    case "UPDATE_ROUTE":
      return { ...state, [action.route]: action.path };
    default:
      return state;
  }
}

export function selections(state = { machine: null, store: null, tool:null }, action) {
  switch (action.type) {
    case "SELECT_OBJECT":
      return { ...state, [action.name]: action.object };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers.js